module.exports = {
	"id": "ET",
	"name": "Ethiopia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.007316,
			"5": 0.003658,
			"6": null,
			"7": 0.003658,
			"8": 0.005487,
			"9": 0.005487,
			"10": 0.014632,
			"11": 0.076818,
			"12": 0.003658,
			"13": 0.005487,
			"14": 0.003658,
			"15": null,
			"16": 0.003658,
			"17": 0.001829,
			"18": 0.003658,
			"19": 0.007316,
			"20": 0.003658,
			"21": null,
			"22": null,
			"23": 0.007316,
			"24": 0.005487,
			"25": 0.010974,
			"26": 0.01829,
			"27": 0.009145,
			"28": 0.003658,
			"29": 0.007316,
			"30": 0.007316,
			"31": 0.144491,
			"32": 0.012803,
			"33": 0.043896,
			"34": 0.005487,
			"35": 0.005487,
			"36": 0.012803,
			"37": 0.003658,
			"38": 0.007316,
			"39": 0.012803,
			"40": 0.082305,
			"41": 0.005487,
			"42": 0.009145,
			"43": 1.172389,
			"44": 0.250573,
			"45": 0.034751,
			"46": 0.025606,
			"47": 0.031093,
			"48": 0.021948,
			"49": 0.305443,
			"50": 0.053041,
			"51": 0.215822,
			"52": 0.124372,
			"53": 3.592156,
			"54": 0.941935,
			"55": 0.051212,
			"56": 0.012803,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.085963,
			"4": 0.042067,
			"5": 0.064015,
			"6": 0.005487,
			"7": 0.007316,
			"8": 0.007316,
			"9": 0.005487,
			"10": 0.032922,
			"11": 0.069502,
			"12": 0.058528,
			"13": 0.016461,
			"14": 0.023777,
			"15": 0.023777,
			"16": 0.021948,
			"17": 0.020119,
			"18": 0.016461,
			"19": 0.034751,
			"20": 0.139004,
			"21": 0.025606,
			"22": 0.025606,
			"23": 0.020119,
			"24": 0.010974,
			"25": 0.051212,
			"26": 0.05487,
			"27": 0.042067,
			"28": 0.047554,
			"29": 0.142662,
			"30": 0.12803,
			"31": 0.085963,
			"32": 0.05487,
			"33": 0.062186,
			"34": 0.067673,
			"35": 0.095108,
			"36": 0.089621,
			"37": 0.115227,
			"38": 0.117056,
			"39": 0.137175,
			"40": 0.118885,
			"41": 0.113398,
			"42": 0.177413,
			"43": 0.471882,
			"44": 0.243257,
			"45": 0.223138,
			"46": 0.217651,
			"47": 0.892552,
			"48": 0.665756,
			"49": 2.052138,
			"50": 0.601741,
			"51": 0.005487,
			"52": null,
			"3.5": null,
			"3.6": 0.012803
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.005487,
			"15": 0.016461,
			"16": 0.007316,
			"17": 0.005487,
			"18": 0.001829,
			"19": 0.001829,
			"20": 0.003658,
			"21": 0.003658,
			"22": 0.003658,
			"23": null,
			"24": 0.003658,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.003658,
			"29": 0.01829,
			"30": null,
			"31": 0.001829,
			"32": 0.003658,
			"33": 0.003658,
			"34": 0.012803,
			"35": 0.009145,
			"36": 0.023777,
			"37": 0.021948,
			"38": 0.029264,
			"39": 0.031093,
			"40": 0.351168,
			"41": 0.040238,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.001829,
			"11.6": 0.023777,
			"12.1": 0.020119
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.001829,
			"6": 0.003658,
			"7": 0.010974,
			"8": 0.012803,
			"9": 0.021948,
			"10": 0.051212,
			"3.1": null,
			"3.2": null,
			"5.1": 0.005487,
			"6.1": null,
			"7.1": null,
			"9.1": 0.040238
		},
		"ios_saf": {
			"8": 0,
			"10": 0.49712472856,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.013396936199,
			"8.1-8.4": 0.0247502719609,
			"9.0-9.2": 0.0118074691923,
			"9.3": 0.180139594088
		},
		"android": {
			"3": 0,
			"4": 0.154890067183,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0193612583979,
			"4.1": 0.558710599483,
			"4.2-4.3": 1.39677649871,
			"4.4": 3.20290531783,
			"4.4.3-4.4.4": 3.2305642584
		},
		"ie": {
			"6": 0.00367632053422,
			"7": 0.00551448080134,
			"8": 0.220579232053,
			"9": 0.0643356093489,
			"10": 0.0882316928214,
			"11": 0.711368023372,
			"5.5": null
		},
		"op_mob": {
			"0": 3.23614474526,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0898929095906
		},
		"edge": {
			"12": 0.082305,
			"13": 0.160952,
			"14": 0.064015
		},
		"ie_mob": {
			"10": 0.0322236619718,
			"11": 0.131196338028
		},
		"bb": {
			"7": 0.00204275,
			"10": null
		},
		"samsung": {
			"0": 0.522944
		},
		"and_uc": {
			"0": 5.80141
		},
		"op_mini": {
			"0": 43.6000153451
		},
		"and_chr": {
			"0": 16.637205
		},
		"and_ff": {
			"0": 0.032684
		}
	},
	"total": 96.8174931089
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ET.json
 ** module id = 517
 ** module chunks = 0
 **/